import Import from '~/src/ui/input/Import';
import { Figure } from '~/src/figure';
import { ToolBar } from '~/src/ui/toolbar/ToolBar';
import { Emitter, useTweaker } from './Figure/Hook';
import { Tweaker } from './Figure';
// import Action from "./figure/Action";
import * as Act from './Figure/Action';
import { AngleConverters, inchConverter } from '../util/Units';
import { mkState } from './Figure/State';
import { useCallback } from 'react';

// import { useTweaker } from "./figure/Hook";

export const _importFailure = ( emit : Emitter ) => ( e : unknown ) : void => {
	alert( 'Import failed, check the browser console for details.');
	console.warn( e );
	emit( Act.setState( null ) );
};

export const _importSuccess = ( emit : Emitter ) => ( fig : Figure ) : void => {
	console.log( 'Imported a figure.' );
	emit( Act.setState( mkState( fig ) ) );
};

export const FigurePage = () => {
	const { emit , state } = useTweaker( null );

	const importFailure = useCallback( ( e : unknown ) => _importFailure( emit )( e ) , [ emit ] );
	const importSuccess = useCallback( ( fig : Figure ) => _importSuccess( emit )( fig ) , [ emit ] );

	return (
		<div className="page figure" style={ { height : '100%' , display : 'flex' , flexDirection : 'column' } }>
			<ToolBar>
				<Import
					name="Figure"
					codec={ Figure }
					failure={ importFailure }
					success={ importSuccess }
				/>
			</ToolBar>

			{ !state ? null :
				<Tweaker
					emit={ emit }
					value={ state }

					width="100%"
					height="100%"

					angleConverter={ AngleConverters.exterior }
					lengthConverter={ inchConverter }
				/>
			}
		</div>
	);
};

export default FigurePage;
